import { useState, useEffect } from "react";

// 공통 미디어쿼리 훅 (Backoffice 모바일 재설계 P1, 2026-09-17).
// window.innerWidth 직접 분기를 여기 한 곳으로 모은다. SSR/구형 브라우저 안전 폴백 포함.
// matchMedia change 이벤트로 리사이즈에 반응(리스너 1개, 리렌더 최소).
export function useMediaQuery(query) {
  const get = () =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(query).matches
      : false;

  const [matches, setMatches] = useState(get);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange(); // 마운트 시 동기화(초기값과 실제가 다를 수 있는 hydration 경계 보정)
    mql.addEventListener?.("change", onChange);
    return () => mql.removeEventListener?.("change", onChange);
  }, [query]);

  return matches;
}

// Backoffice 데스크톱 경계는 md(768px) — Tailwind md 와 일치. < 768px = 모바일 composition.
export function useIsMobile() {
  return useMediaQuery("(max-width: 767px)");
}
